/**
 * Export all constructs under the models namespace.
 */

export * from "@courses-models/institution/src/ts/config/api";
